import React, {useState} from 'react';
import '../Styles/Home.css';

let blurb = 'Hi there! My name is Jeton Koka and I love code! I graduated from the NYU Tandon School of Engineering with a B.S. In Computer Science & Engineering and a minor in Electrical Engineering. My passion for Software Development lies in automating workflows and creating accessible user interfaces. ' +
'My hobbies include music production, DJing, taking pictures with my Canon 50D (and my iPhone), and Muay Thai. I have two amazing cats who help peer review my code and also provide cuddles. '


function HomePage() {
    const [summary] = useState(blurb);
    return (
        <div id="aboutme"className="Home-Wrapper">
            <h2>About Me:</h2>
            <div className="Summary">
               {summary}
            </div>
        </div>
    )
}

export default HomePage;


// WEBPACK FOOTER //
// ./src/Components/Home.js